"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectTimestamps = exports.selectSteps = exports.selectPrevPage = exports.selectLoaderText = exports.selectIsLoading = exports.selectIsGuidedSellingModalOpen = exports.selectIsFloaterOpen = exports.selectIsCheckoutInProgress = exports.selectIcons = exports.selectHasError = exports.selectCurrentPage = exports.selectCurrentModalSize = exports.selectCurrentDynamicPage = void 0;
const selectIsLoading = instanceId => state => {
  return state.drools[instanceId].ui.isLoading === true;
};
exports.selectIsLoading = selectIsLoading;
const selectLoaderText = instanceId => state => {
  return state.drools[instanceId].ui.loaderText;
};
exports.selectLoaderText = selectLoaderText;
const selectCurrentPage = instanceId => state => {
  return state.drools[instanceId].ui.currentPage;
};
exports.selectCurrentPage = selectCurrentPage;
const selectHasError = instanceId => state => {
  return state.drools[instanceId].ui.error;
};
exports.selectHasError = selectHasError;
const selectIsGuidedSellingModalOpen = instanceId => state => {
  var _state$drools$instanc, _state$drools$instanc2;
  return (_state$drools$instanc = state.drools[instanceId]) === null || _state$drools$instanc === void 0 ? void 0 : (_state$drools$instanc2 = _state$drools$instanc.ui) === null || _state$drools$instanc2 === void 0 ? void 0 : _state$drools$instanc2.isGuidedSellingModalOpen;
};
exports.selectIsGuidedSellingModalOpen = selectIsGuidedSellingModalOpen;
const selectIsCheckoutInProgress = instanceId => state => {
  return state.drools[instanceId].ui.isCheckoutInProgress;
};
exports.selectIsCheckoutInProgress = selectIsCheckoutInProgress;
const selectTimestamps = instanceId => state => {
  return state.drools[instanceId].ui.timestamps;
};
exports.selectTimestamps = selectTimestamps;
const selectCurrentModalSize = instanceId => state => {
  return state.drools[instanceId].ui.currentModalSize;
};
exports.selectCurrentModalSize = selectCurrentModalSize;
const selectPrevPage = instanceId => state => {
  return state.drools[instanceId].ui.PrevPage;
};
exports.selectPrevPage = selectPrevPage;
const selectIsFloaterOpen = instanceId => state => {
  var _state$drools$instanc3, _state$drools$instanc4;
  return (_state$drools$instanc3 = state.drools[instanceId]) === null || _state$drools$instanc3 === void 0 ? void 0 : (_state$drools$instanc4 = _state$drools$instanc3.ui) === null || _state$drools$instanc4 === void 0 ? void 0 : _state$drools$instanc4.isFloaterOpen;
};
exports.selectIsFloaterOpen = selectIsFloaterOpen;
const selectCurrentDynamicPage = instanceId => state => state.drools[instanceId].ui.currentDynamicPage;
exports.selectCurrentDynamicPage = selectCurrentDynamicPage;
const selectIcons = instanceId => state => state.drools[instanceId].ui.icons;
exports.selectIcons = selectIcons;
const selectSteps = instanceId => state => state.drools[instanceId].ui.journrySteps;
exports.selectSteps = selectSteps;